import React, { useState, useEffect } from 'react';
import './AvailabilityModal.css';

const AvailabilityModal = ({ isOpen, onClose, onConfirm }) => {
  const [formData, setFormData] = useState({
    fromDate: "",
    toDate: "",
    adults: "2",
    children: "0",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (formData.fromDate && formData.toDate) {
      onConfirm(formData);
    } else {
      alert("Please select valid dates.");
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Prevent body scrolling when modal is open
  // useEffect(() => {
  //   if (isOpen) {
  //     document.body.style.overflow = 'hidden';
  //   } else {
  //     document.body.style.overflow = 'unset';
  //   }
    
  //   // Cleanup on unmount
  //   return () => {
  //     document.body.style.overflow = 'unset';
  //   };
  // }, [isOpen]);

  if (!isOpen) return null;

  return (
  
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal">
        <button className="close-btn" onClick={onClose}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        
        <div className="modal-header">
          <div className="header-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
          </div>
          <h3>Check Availability</h3>
          <p>Select your dates and guest count</p>
        </div>
        
        <div className="modal-content">
          <div className="date-inputs">
            <div className="input-group">
              <label>Check-in</label>
              <input 
                type="date" 
                name="fromDate" 
                value={formData.fromDate}
                onChange={handleChange}
                className="date-input"
              />
            </div>
            <div className="input-group">
              <label>Check-out</label>
              <input 
                type="date" 
                name="toDate" 
                value={formData.toDate}
                onChange={handleChange}
                className="date-input"
              />
            </div>
          </div>
          
          <div className="guest-inputs">
            <div className="input-group">
              <label>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
                Adults
              </label>
              <select 
                name="adults" 
                value={formData.adults}
                onChange={handleChange}
                className="guest-select"
              >
                {[...Array(10)].map((_, i) => (
                  <option key={i} value={i + 1}>{i + 1}</option>
                ))}
              </select>
            </div>
            <div className="input-group">
              <label>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                Children
              </label>
              <select 
                name="children" 
                value={formData.children}
                onChange={handleChange}
                className="guest-select"
              >
                {[...Array(6)].map((_, i) => (
                  <option key={i} value={i}>{i}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
        
        <div className="modal-actions">
          <button className="btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="btn-primary" onClick={handleSubmit}>
            Check Availability
          </button>
        </div>
      </div>
    </div>
  );
};

export default AvailabilityModal;